<rpe-page-template title="{{ 'rpe.vista-registro-empresa.title' | translate }}" route="main/landing">
<ng-container slot="content">
  <div class="container">
    <mat-card>
      <div>
        <mat-card-content>
          <div class="row">
            <rpe-entity-registro-empresa-form-container></rpe-entity-registro-empresa-form-container>
          </div>
        </mat-card-content>
      </div> 
    </mat-card>
    </div>
  </ng-container>
</rpe-page-template>
